import React from 'react';
import VenueDirectoryPage from '../components/VenueDirectoryPage';

function VenuesDirectory(props) {
    return (
        <div style={{ padding: '20px', color: 'white' }}>
           
           <VenueDirectoryPage/>
        </div>
    );
}

export default VenuesDirectory;